export * from './palette-var-names.enum';
